/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is URL-safe Base64?`)
};

const es_b64_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es Base64 seguro para URL?`)
};

const de_b64_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist URL-sicheres Base64?`)
};

const nl_b64_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is URL-veilige Base64?`)
};

const fr_b64_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que Base64 sûr pour les URL ?`)
};

const it_b64_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è il Base64 URL-safe?`)
};

const pt_br2_b64_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é Base64 seguro para URL?`)
};

const pt_b64_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é Base64 seguro para URL?`)
};

const ja_b64_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-safe Base64とは何ですか?`)
};

const zh_b64_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 URL 安全的 Base64？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_faq2_q", locale)
	if (locale === "en") return en_b64_faq2_q(inputs)
	if (locale === "es") return es_b64_faq2_q(inputs)
	if (locale === "de") return de_b64_faq2_q(inputs)
	if (locale === "nl") return nl_b64_faq2_q(inputs)
	if (locale === "fr") return fr_b64_faq2_q(inputs)
	if (locale === "it") return it_b64_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_b64_faq2_q(inputs)
	if (locale === "pt") return pt_b64_faq2_q(inputs)
	if (locale === "ja") return ja_b64_faq2_q(inputs)
	return zh_b64_faq2_q(inputs)
};